import React, {useState} from 'react';

export default function HomeVideoBanner({videoUrl, posterUrl, title}) {
    const [posterReady, setPosterReady] = useState(!posterUrl);
    const [posterFailed, setPosterFailed] = useState(false);
    const [playing, setPlaying] = useState(false);
    const hasPoster = Boolean(posterUrl) && !posterFailed;

    return <section className="ps-header__video-banner ps-storefront-video-banner">
        <div className={`ps-header__video-frame ps-storefront-video-banner__frame${playing ? ' ps-storefront-video-banner__frame--playing' : ''}`}>
            {hasPoster && <img className="ps-storefront-video-banner__poster" src={posterUrl} alt="" aria-hidden="true" loading="eager" fetchpriority="high" decoding="async"
                onLoad={() => setPosterReady(true)}
                onError={() => {setPosterFailed(true); setPosterReady(true);}}/>}
            {posterReady && <video
                className={`ps-header__video ps-storefront-video-banner__video${hasPoster ? ' ps-storefront-video-banner__video--with-poster' : ''}`}
                src={videoUrl} poster={posterUrl || undefined}
                autoPlay muted loop playsInline preload="metadata" aria-label={title}
                onPlaying={() => setPlaying(true)} onError={() => setPlaying(false)}
            />}
        </div>
    </section>;
}
